import React, { Component } from 'react';
import { SettingsContext } from '../components/SettingsContext';
import NavMenuWithRouter from '../components/NavMenu';

export class Layout extends Component {
	static displayName = Layout.name;
	static contextType = SettingsContext;

	render() {
		const bannerText = this.context.devBannerText;
		const showBanner = this.context.isDev && bannerText;

		return (
			<div>
				{
					showBanner ?
						<div id="dev-banner">{bannerText}</div>
					: null
				}

				<NavMenuWithRouter />

				<div className={this.context.containerClass}>
					{this.props.children}
				</div>

				<footer className={this.context.containerClass}>
					<hr />
					<p className="disclaimer small text-left">
						Personal information is protected under BC privacy laws and is collected under the authority of section 26(c)
            of the <i>Freedom of Information Protection of Privacy Act</i>. All data will be securely stored at PHSA and will not be used for any other
						purpose other than the one stated above. If you have any questions about the collection of this personal information please contact
            PHSA's Information Access & Privacy Office at 1-855-229-9800 or at <a href="mailto:privacyandfoi@phsa.ca">privacyandfoi@phsa.ca</a>.
					</p>
					<p className="disclaimer small text-left">
						The Provincial eForms Solution is monitored between the hours of 8AM - 5PM Monday through Friday, excluding holidays. 
						If you are experiencing difficulties with the eForms application please email the eForms Solution team at <a href="mailto:eFormsSolution@phsa.ca">eFormsSolution@phsa.ca</a>. 
						If you are experiencing issues outside of monitoring hours please revert to your downtime procedures and someone will reply to you the next business day.  
						If you have questions about the Provincial eForms Solution, please follow this link <a href="https://eformsinfo.healthcarebc.ca/">here</a> for more information. 
						
					</p>
				</footer>
			</div>
		);
	}
}
